import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { boolean, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';

export const customers = pgTable('customers', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  name: text('name').notNull(),
  email: text('email'),
  phone: text('phone').notNull(),
  documentNumber: text('document_number').notNull(),
  zipCode: text('zip_code'),
  street: text('street'),
  number: text('number'),
  complement: text('complement'),
  neighborhood: text('neighborhood'),
  city: text('city'),
  state: text('state'),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export type Customer = InferSelectModel<typeof customers>;
export type CreateCustomerInput = InferInsertModel<typeof customers>;
export type UpdateCustomerInput = Partial<CreateCustomerInput>;
